import { render, staticRenderFns } from "./GenericTable.vue?vue&type=template&id=38ab3aac&scoped=true&class=true&"
import script from "./GenericTable.vue?vue&type=script&lang=js&"
export * from "./GenericTable.vue?vue&type=script&lang=js&"
import style0 from "./GenericTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GenericTable.vue?vue&type=style&index=1&id=38ab3aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab3aac",
  null
  
)

export default component.exports